import { MouseEventHandler } from 'react';
import { RAside } from './types';

export const handleOpenAside = (asideId: string) => {
  const openAside: MouseEventHandler<HTMLElement> = () => {
    const element = document.querySelector(`#${asideId}-aside`) as RAside;

    element?.open();
  };

  return openAside;
};

export const handleCloseAside = (asideId: string) => {
  const closeAside: MouseEventHandler<HTMLElement> = () => {
    const element = document.querySelector(`#${asideId}-aside`) as RAside;

    element?.close();
  };

  return closeAside;
};
